const RtmChannelMessageEnum = {
  LIVE_CHAT: "LIVE_CHAT",
  DEBATE_START: "DEBATE_START",
  INTERVAL_FINISH: "INTERVAL_FINISH",
  WINNER_RESULT: "WINNER_RESULT",
  SET_WINNER: "SET_WINNER",
  SET_LIVE_CHAT: "SET_LIVE_CHAT",
  ALLOW_TO_MOVE_TO_NEXT_MOTION: "ALLOW_TO_MOVE_TO_NEXT_MOTION",
};

export default RtmChannelMessageEnum;
